export const QSIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 18 18"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_5_1969)">
        <path d="M10.0042 5.793L11.049 4.71525L12.2715 5.90025L14.6925 3.51975L15.744 4.58925L13.152 7.1385C12.921 7.37025 12.6068 7.5 12.2723 7.5C11.9378 7.5 11.6243 7.3695 11.388 7.13325L10.0042 5.793ZM7.5 5.25C7.5 2.355 9.85575 0 12.75 0C15.6442 0 18 2.355 18 5.25C18 8.145 15.6442 10.5 12.75 10.5C9.85575 10.5 7.5 8.145 7.5 5.25ZM9 5.25C9 7.31775 10.6823 9 12.75 9C14.8177 9 16.5 7.31775 16.5 5.25C16.5 3.18225 14.8177 1.5 12.75 1.5C10.6823 1.5 9 3.18225 9 5.25ZM15 12.75H17.625V15.375C17.625 16.8225 16.4475 18 15 18H6.375C4.9275 18 3.75 16.8225 3.75 15.375V5.25H0V2.625C0 1.1775 1.1775 0 2.625 0H8.508C7.97925 0.4275 7.5165 0.93375 7.137 1.5H4.9965C5.15925 1.84125 5.25 2.223 5.25 2.625V15.375C5.25 15.9952 5.75475 16.5 6.375 16.5C6.99525 16.5 7.5 15.9952 7.5 15.375V12.75H13.5V11.958C14.0205 11.9003 14.5223 11.784 15 11.6153V12.75ZM3.75 2.625C3.75 2.00475 3.24525 1.5 2.625 1.5C2.00475 1.5 1.5 2.00475 1.5 2.625V3.75H3.75V2.625ZM9 14.25V15.375C9 15.7778 8.90925 16.1588 8.7465 16.5H15C15.6202 16.5 16.125 15.9952 16.125 15.375V14.25H9Z" />
      </g>
      <defs>
        <clipPath id="clip0_5_1969">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
